import React from 'react'
import { Pie, PieChart, Tooltip, TooltipIndex, ResponsiveContainer, Label, Cell } from 'recharts';
export default function PieCharts({ heading, pieData, height,centerData }) {

    return (
        <>
            <div className='Areachart-box'>
                <div className='topHeader'>
                    <div>
                        <h5>{heading}</h5>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-sm-7 col-xs-12">
                        <div style={{ height: height + "px" }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart

                                    responsive
                                >
                                    <Pie
                                        data={pieData}
                                        dataKey="value"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius="100%"
                                        innerRadius="60%"
                                        fill="#8884d8"
                                        cornerRadius={20}
                                         paddingAngle={-20}  
                                         stroke="transparent"
                                         strokeWidth={0}
                                        isAnimationActive={true}
                                    >
                                        {pieData?.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.colorTheme} />
                                        ))}
                                        <Label
                                            value={`Average Daily Spent`}
                                            position="center"
                                            dy={-8}
                                            style={{
                                                fontSize: '10px',
                                                fontWeight: '600',
                                                fill: '#686C70'
                                            }}
                                        />
                                        <Label
                                            value={centerData ?? 0}
                                            position="center"
                                            dy={8}
                                            style={{
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                fill: '#0C0B10'
                                            }}
                                        />
                                    </Pie>

                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    <div className="col-sm-5 col-xs-12">
                        <div className='customLegend-pie'>
                            {
                                pieData?.length > 0 ? pieData?.map((val, id) => {
                                    return (
                                        <div style={{ display: 'flex', gap: '5px', alignItems: 'center', marginTop: '20px' }} key={id}>
                                            <div style={{ width: '16px', height: '16px', borderRadius: '50%', background: val?.colorTheme }}></div>
                                            <div>
                                                <h5>{val?.name ?? ""}</h5>
                                                <h6>{val?.value ?? ""} %</h6>
                                            </div>
                                        </div>
                                    )
                                })
                                    : ''}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
